import { render, staticRenderFns } from "./HelpFourthPage.vue?vue&type=template&id=50909ad0&"
import script from "./HelpFourthPage.vue?vue&type=script&lang=js&"
export * from "./HelpFourthPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports